import axios from "axios"
import * as env from "../constants/env"
import { utils } from "../helpers"


/* HEADERS OF EVERY REQUEST OF THE SECTION */
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } })


/* List Bookings — the tab decides what the list holds: the upcoming reservations or the history */
export const list = ({ page = 1, type = "upcoming", search = "", operators = "", tables = "", status = "", start = "", end = "" }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ page: page || 1, type, timezone: utils.getTimezone() })

    if (search) params.set("search", search)
    if (operators) params.set("operators", operators)
    if (tables) params.set("tables", tables)
    if (status !== "") params.set("status", status)
    if (start) params.set("start", start)
    if (end) params.set("end", end)

    /* Send Request */
    const uri = `${env.startpoint}booking/list?${params.toString()}`

    return axios.get(uri, auth()).then((response) => response).catch((data) => data.response)
}


/* Filters Of The Section — the operators and the VIP games of the token, nothing beyond the scope */
export const filters = () => {

    const uri = `${env.startpoint}booking/filters`

    return axios.get(uri, auth()).then((response) => response).catch((data) => data.response)
}


/* The Player Behind An ID — the form shows whose reservation is being written */
export const player = ({ player, operatorID = "" }) => {

    /* Prepare Params */
    const params = new URLSearchParams({ player })

    if (operatorID) params.set("operatorID", operatorID)

    /* Send Request */
    const uri = `${env.startpoint}booking/player?${params.toString()}`

    return axios.get(uri, auth()).then((response) => response).catch((data) => data.response)
}


/* Create Booking — the borders of the window leave in the timezone of the panel */
export const create = (data) => {

    const uri = `${env.startpoint}booking/create`

    return axios.post(uri, { ...data, timezone: utils.getTimezone() }, auth()).then((response) => response).catch((data) => data.response)
}


/* Cancel Booking — a reservation is called off at any time, the row stays in the history */
export const cancel = (data) => {

    const uri = `${env.startpoint}booking/cancel`

    return axios.post(uri, data, auth()).then((response) => response).catch((data) => data.response)
}


/* Move The Window Of A Booking — the very same row is held longer or shorter, the borders leave as
   absolute moments, so nothing on the way can read them in a wrong timezone */
export const updateWindow = (data) => {

    const uri = `${env.startpoint}booking/window`

    return axios.post(uri, { ...data, timezone: utils.getTimezone() }, auth()).then((response) => response).catch((data) => data.response)
}


/* Sessions Of A Booking — the arrival is written by the start of the session, not by hand */
export const sessions = (id) => {

    const uri = `${env.startpoint}booking/sessions?id=${id}`

    return axios.get(uri, auth()).then((response) => response).catch((data) => data.response)
}
